__turbopack_context__.v({
  "alignment_bottom": "styles-module-scss-module__ks6yWa__alignment_bottom",
  "alignment_center": "styles-module-scss-module__ks6yWa__alignment_center",
  "alignment_top": "styles-module-scss-module__ks6yWa__alignment_top",
  "spacing_bottom_medium": "styles-module-scss-module__ks6yWa__spacing_bottom_medium",
  "spacing_bottom_none": "styles-module-scss-module__ks6yWa__spacing_bottom_none",
  "spacing_bottom_small": "styles-module-scss-module__ks6yWa__spacing_bottom_small",
  "text": "styles-module-scss-module__ks6yWa__text",
  "text_align_center": "styles-module-scss-module__ks6yWa__text_align_center",
  "text_align_left": "styles-module-scss-module__ks6yWa__text_align_left",
  "text_align_right": "styles-module-scss-module__ks6yWa__text_align_right",
  "text_link": "styles-module-scss-module__ks6yWa__text_link",
  "wrapper": "styles-module-scss-module__ks6yWa__wrapper",
});
